























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import PaymentsExported from "./PaymentsExported.vue";

import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Payments",
  components: {
    MainTabbar,
    PaymentsExported,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Exportiert",
          linkedComponent: "PaymentsExported",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
        },
      ] as ModulesJson[];
    },
  },
});
